module.exports = {
    TRANSFER_PASS: {
        ALPHANUM: 30,
        OPERATION_ID: 22
    }
};
